import React, { useRef, useState, useEffect } from 'react'
import PropTypes from 'prop-types'

import { useMountEffect } from '@/hook'

import {
  Container,
  Wrapper,
  Content,
  ContentClone,
  Text
} from './style'

const TextScroll = ({ text, duration }) => {
  const [reps, setReps] = useState(1)
  const containerRef = useRef(null)
  const contentRef = useRef(null)

  useMountEffect(() => {
    if (contentRef.current && containerRef.current) {
      const parent = containerRef.current
      const item = contentRef.current
      const itemWidth = item.offsetWidth
      const parentWidth = parent.offsetWidth

      setReps(Math.ceil(parentWidth / itemWidth) + 2)
    }
  })

  return (
    <Container ref={ containerRef }>
      <Wrapper duration={ duration }>
        <Content ref={ contentRef }>
          <Text>
            { text }
          </Text>
        </Content>
        {
          [...Array(reps)].map((v, i) => (
            <ContentClone key={ i } index={ i }>
              <Text>
                { text }
              </Text>
            </ContentClone>
          ))
        }
      </Wrapper>
    </Container>
  )
}

TextScroll.propTypes = {
  text: PropTypes.string.isRequired,
  duration: PropTypes.string
}

export default TextScroll
